/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CustomerOrderExportDto { 
    accessCode?: string | null;
    firstName?: string | null;
    employeeId?: string | null;
    unlockCode?: string | null;
    lastName?: string | null;
    email?: string | null;
    wallet?: string | null;
}

